// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper:not(:empty) + .default {
  display: none;
}

.card {
  width: 100%;
  padding: 15px 15px 0px 21px;
  margin-top: 10px;
}

.cardtitle {
  font-weight: 600;
}

.content {
  background-color: var(--color-card-background);
  padding: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: var(--color-card-text);
}

.sub-content {
  display: flex;
  justify-content: center;
  padding: 15px;
}

ol {
  padding-left: 15px;
}

li {
  margin-top: 10px;
}

.error {
  margin: 20px 0px 0px 0px;
}

.header {
  position: relative;
  text-align: center;
  color: white;
}
.header img {
  height: 240px;
  width: 100%;
  object-fit: cover;
}

.centered {
  position: absolute;
  width: 800px;
  top: 50%;
  left: 50%;
  font-size: 45px;
  font-weight: 700;
  transform: translate(-50%, -50%);
}

.centeredHead {
  position: absolute;
  width: 800px;
  top: 30%;
  left: 50%;
  font-size: 45px;
  font-weight: 700;
  transform: translate(-50%, -50%);
}

.centeredCase {
  position: absolute;
  width: 800px;
  top: 60%;
  left: 50%;
  font-size: 45px;
  font-weight: 700;
  transform: translate(-50%, -50%);
}

.sub-contentCase {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.sub-contentInstuct {
  padding: 10px 0px 15px 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.modal-header {
  border-bottom-color: var(--color-primary);
}

.modal-footer {
  border-top-color: var(--color-primary);
}

.btn-ok.focus,
.btn-ok:focus {
  outline: 0;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/desktop/d-landing-page/return/return.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AAEF;;AAAA;EACE,gBAAA;AAGF;;AADA;EACE,8CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AAIF;;AAFA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AAKF;;AAHA;EACE,kBAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,wBAAA;AAQF;;AANA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AASF;AARE;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AAUJ;;AAPA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAUF;;AAPA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAUF;;AARA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAWF;;AATA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAYF;;AAVA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAaF;;AAXA;EACE,yCAAA;AAcF;;AAXA;EACE,sCAAA;AAcF;;AAXA;;EAEE,UAAA;EACA,2BAAA;AAcF","sourcesContent":[".wrapper:not(:empty) + .default {\n  display: none;\n}\n.card {\n  width: 100%;\n  padding: 15px 15px 0px 21px;\n  margin-top: 10px;\n}\n.cardtitle {\n  font-weight: 600;\n}\n.content {\n  background-color: var(--color-card-background);\n  padding: 15px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  color: var(--color-card-text);\n}\n.sub-content {\n  display: flex;\n  justify-content: center;\n  padding: 15px;\n}\nol {\n  padding-left: 15px;\n}\nli {\n  margin-top: 10px;\n}\n.error {\n  margin: 20px 0px 0px 0px;\n}\n.header {\n  position: relative;\n  text-align: center;\n  color: white;\n  img {\n    height: 240px;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n.centered {\n  position: absolute;\n  width: 800px;\n  top: 50%;\n  left: 50%;\n  font-size: 45px;\n  font-weight: 700;\n  transform: translate(-50%, -50%);\n}\n\n.centeredHead {\n  position: absolute;\n  width: 800px;\n  top: 30%;\n  left: 50%;\n  font-size: 45px;\n  font-weight: 700;\n  transform: translate(-50%, -50%);\n}\n.centeredCase {\n  position: absolute;\n  width: 800px;\n  top: 60%;\n  left: 50%;\n  font-size: 45px;\n  font-weight: 700;\n  transform: translate(-50%, -50%);\n}\n.sub-contentCase {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n}\n.sub-contentInstuct {\n  padding: 10px 0px 15px 0px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n.modal-header {\n  border-bottom-color: var(--color-primary);\n}\n\n.modal-footer {\n  border-top-color: var(--color-primary);\n}\n\n.btn-ok.focus,\n.btn-ok:focus {\n  outline: 0;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
